import { render, staticRenderFns } from "./StudentGradesCourse.vue?vue&type=template&id=8961940a"
import script from "./StudentGradesCourse.vue?vue&type=script&lang=js"
export * from "./StudentGradesCourse.vue?vue&type=script&lang=js"
import style0 from "./StudentGradesCourse.vue?vue&type=style&index=0&id=8961940a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports